<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bud8Vv/tc-custom/9781526734846.jpg?1728726247504" alt="This image is the cover for the book Following in the Footsteps of Oliver Cromwell"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Following in the Footsteps of Oliver Cromwell
      </h1>
      <p class="bookDescription body article font2">
        <b>A unique biography of the military commander and politician who remains one of Britain’s most controversial figures centuries after his death.</b><br/>  <br/> One of the most important figures in British history, Oliver Cromwell was both soldier and politician and the only non-Royal ruler of Britain in a thousand years. His actions and ideas still have political and social consequences today, and his legacy still divides people. Love him or loathe him, Cromwell still matters.<br/>  <br/> This book is a history of his life through the places in Britain and Ireland where he lived, visited, ruled, or fought. <i>Following in the Footsteps of Oliver Cromwell</i> begins in Huntingdon in 1599, with the respectable but unimportant Cromwell family living under the shadow of richer relatives. Civil War and Cromwell’s controversial successes at Marston Moor, Naseby, Basing House, and Worcester transform him into the most powerful person in Britain, saving him from obscurity and moving him from a modest house in Ely to Hampton Court Palace. Cromwell is involved in the execution of King Charles I outside the Banqueting House, his own coronation in Westminster Hall, and bloody slaughter in Ireland. Even his death in 1658 does not end the controversy—as his enemies take revenge on his corpse and the debate about his legacy begins.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James Hobson
      </h2>
      
      <p class="authorDescription body article">James Hobson has taught and written about History as teacher for twenty-five years. His first book was The Dark Days of Georgian Britain, a social history of the Regency period. His other interest is the civil war &ndash; studying this as his specialism under Professor John Morrill while at the University of Cambridge.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword / Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38762a11